/* ON Móveis · origem no WhatsApp (v238)
   A mensagem do WhatsApp passa a dizer de onde a pessoa chegou ao site ("Vim do site pelo Google e estou
   com uma dúvida sobre o produto: ..."). O funil comercial do Painel ON lê essa frase e sabe o canal de cada
   conversa sem depender do Google Analytics. No link do produto que vai na mensagem entra também
   utm_content com o canal.
   Guarda só o canal (ex.: "google"), neste navegador, por 30 dias: vale o último canal conhecido, e um acesso
   direto não apaga o anterior. Nenhum dado da pessoa. Só mexe nos links de WhatsApp da loja (os de
   compartilhar com um amigo ficam como estão). */
(function () {
  'use strict';
  var CHAVE = 'onm_origem', DIAS = 30;

  var FRASE = {
    'google': 'pelo Google', 'google-ads': 'pelo anúncio do Google',
    'instagram': 'pelo Instagram', 'instagram-ads': 'pelo anúncio do Instagram',
    'facebook': 'pelo Facebook', 'facebook-ads': 'pelo anúncio do Facebook', 'meta-ads': 'por um anúncio',
    'tiktok': 'pelo TikTok', 'tiktok-ads': 'pelo anúncio do TikTok',
    'youtube': 'pelo YouTube', 'pinterest': 'pelo Pinterest',
    'chatgpt': 'pelo ChatGPT', 'perplexity': 'pelo Perplexity', 'gemini': 'pelo Gemini', 'copilot': 'pelo Copilot', 'claude': 'pelo Claude',
    'bing': 'pelo Bing', 'busca': 'por uma busca',
    'linktree': 'pelo link da bio', 'email': 'pelo e-mail', 'grupo': 'pelo grupo do WhatsApp'
  };

  function ler() {
    try {
      var o = JSON.parse(localStorage.getItem(CHAVE) || 'null');
      if (o && o.k && FRASE[o.k] && Date.now() - o.em < DIAS * 864e5) return o;
    } catch (e) {}
    return null;
  }
  function gravar(k) { try { localStorage.setItem(CHAVE, JSON.stringify({ k: k, em: Date.now() })); } catch (e) {} }

  function param(nome) {
    var m = new RegExp('[?&]' + nome + '=([^&#]*)', 'i').exec(location.search);
    if (!m) return '';
    try { return decodeURIComponent(m[1].replace(/\+/g, ' ')).toLowerCase().trim(); } catch (e) { return m[1].toLowerCase(); }
  }
  function dominio(u) {
    var m = /^[a-z][a-z0-9+.-]*:\/\/([^\/?#:]+)/i.exec(u || '');
    return m ? m[1].toLowerCase().replace(/^www\./, '') : '';
  }
  function eh(d, lista) {
    for (var i = 0; i < lista.length; i++) if (d === lista[i] || d.slice(-(lista[i].length + 1)) === '.' + lista[i]) return true;
    return false;
  }

  /* o canal desta entrada no site; '' quando não dá para saber (acesso direto ou link interno) */
  function canal() {
    var src = param('utm_source'), med = param('utm_medium');
    var ref = dominio(document.referrer), casa = location.hostname.toLowerCase().replace(/^www\./, '');
    if (ref === casa || /(^|\.)(myshopify\.com|shopify\.com|shop\.app)$/.test(ref)) ref = '';
    var ua = navigator.userAgent || '';
    var organico = !med || /^(social|organic|organico|orgânico|bio|perfil|referral|link|post|stories|story)$/.test(med);

    /* anúncio com identificador de clique */
    if (param('gclid') || param('gbraid') || param('wbraid') || param('gad_source')) return 'google-ads';
    if (param('ttclid')) return 'tiktok-ads';

    /* utm do link */
    if (src) {
      if (src === 'whatsapp') return med === 'atendimento' ? '' : 'grupo';
      if (/^(google|youtube)/.test(src) && !organico) return 'google-ads';
      if (/^google/.test(src)) return 'google';
      if (/^(facebook|fb|meta|instagram|ig)$/.test(src)) {
        if (!organico) return /instagram|^ig/.test(med) || /^(instagram|ig)$/.test(src) ? 'instagram-ads' : /facebook|^fb/.test(med) ? 'facebook-ads' : 'meta-ads';
        return /^(instagram|ig)$/.test(src) ? 'instagram' : 'facebook';
      }
      if (/^tiktok/.test(src)) return organico ? 'tiktok' : 'tiktok-ads';
      if (/linktr/.test(src)) return 'linktree';
      if (/chatgpt|openai/.test(src)) return 'chatgpt';
      if (/perplexity/.test(src)) return 'perplexity';
      if (/gemini/.test(src)) return 'gemini';
      if (/copilot/.test(src)) return 'copilot';
      if (/^claude/.test(src)) return 'claude';
      if (/youtube/.test(src)) return 'youtube';
      if (/pinterest/.test(src)) return 'pinterest';
      if (/^bing/.test(src)) return 'bing';
      if (/sendflow/.test(src)) return 'grupo';
      if (/(klaviyo|martz|e-?mail|newsletter)/.test(src) || /^(e-?mail|newsletter)$/.test(med)) return 'email';
    }
    if (/^(e-?mail|newsletter)$/.test(med)) return 'email';

    /* de onde veio o clique */
    if (ref) {
      if (eh(ref, ['gemini.google.com', 'bard.google.com'])) return 'gemini';
      if (eh(ref, ['googleadservices.com', 'googlesyndication.com', 'doubleclick.net'])) return 'google-ads';
      if (eh(ref, ['mail.google.com', 'outlook.live.com', 'outlook.office.com', 'mail.yahoo.com'])) return 'email';
      if (/^(.+\.)?google\.[a-z.]+$/.test(ref)) return 'google';
      if (eh(ref, ['instagram.com'])) return 'instagram';
      if (eh(ref, ['facebook.com', 'fb.com', 'messenger.com'])) return 'facebook';
      if (eh(ref, ['tiktok.com'])) return 'tiktok';
      if (eh(ref, ['youtube.com', 'youtu.be'])) return 'youtube';
      if (/(^|\.)pinterest\.[a-z.]+$/.test(ref) || eh(ref, ['pin.it'])) return 'pinterest';
      if (eh(ref, ['chatgpt.com', 'chat.openai.com', 'openai.com'])) return 'chatgpt';
      if (eh(ref, ['perplexity.ai'])) return 'perplexity';
      if (eh(ref, ['copilot.microsoft.com'])) return 'copilot';
      if (eh(ref, ['claude.ai'])) return 'claude';
      if (eh(ref, ['bing.com'])) return 'bing';
      if (eh(ref, ['duckduckgo.com', 'yahoo.com', 'ecosia.org', 'search.brave.com'])) return 'busca';
      if (eh(ref, ['linktr.ee'])) return 'linktree';
      return '';
    }

    /* navegador de dentro do app (não manda de onde veio) */
    if (/Instagram/.test(ua)) return 'instagram';
    if (/FBAN|FBAV|FB_IAB/.test(ua)) return 'facebook';
    if (/musical_ly|Bytedance|TikTok/i.test(ua)) return 'tiktok';
    return '';
  }

  var achado = canal();
  if (achado) gravar(achado);

  /* a frase entra no começo, depois do "Olá!": "Olá! Vim do site pelo Google. Tenho interesse neste móvel..." */
  function comOrigem(t, k) {
    var frase = FRASE[k];
    t = t || '';
    if (!t.replace(/\s/g, '')) return 'Olá! Vim do site ' + frase + '.';
    if (/vim do site( da on m[oó]veis)? (pel[oa]|por) /i.test(t)) return t;
    if (/vim do site/i.test(t)) t = t.replace(/vim do site/i, function (m) { return m + ' ' + frase; });
    else if (/vim pelo site da on m[oó]veis/i.test(t)) t = t.replace(/vim pelo site da (on m[oó]veis)/i, function (m, on) { return 'Vim do site da ' + on + ' ' + frase; });
    else {
      var g = /^\s*(?:ol[aá]+|oi+e?|bom dia|boa tarde|boa noite)\s*[!,.]*\s*(?:tudo bem\s*[?!.]*\s*)?/i.exec(t);
      var ini = g ? g[0].replace(/\s*$/, ' ') : '', corpo = g ? t.slice(g[0].length) : t;
      t = ini + 'Vim do site ' + frase + '.' + (corpo ? ' ' + corpo : '');
    }
    /* o link do produto que vai na mensagem leva o canal no utm_content */
    return t.replace(/(utm_source=whatsapp&utm_medium=atendimento&utm_campaign=[\w-]+)(?!&utm_content)/g, '$1&utm_content=' + k);
  }

  function numeroDaLoja(href) {
    var m = /^https?:\/\/(?:wa\.me\/(\d*)|(?:api\.|web\.)?whatsapp\.com\/send\/?\?(?:[^#]*&)?phone=(\d+))/i.exec(href || '');
    if (!m) return false;
    var num = m[1] || m[2] || '';
    if (!num) return false;
    var loja = String((window.ONM && window.ONM.zap && window.ONM.zap.num) || '').replace(/\D/g, '');
    return !loja || num === loja || num.slice(-10) === loja.slice(-10);
  }

  function ajustar(href) {
    var o = ler();
    if (!o || !numeroDaLoja(href)) return href;
    var i = href.indexOf('?'), base = i < 0 ? href : href.slice(0, i), q = i < 0 ? '' : href.slice(i + 1), hash = '';
    var j = q.indexOf('#');
    if (j >= 0) { hash = q.slice(j); q = q.slice(0, j); }
    var partes = q ? q.split('&') : [], achou = false;
    for (var n = 0; n < partes.length; n++) {
      if (!/^text=/i.test(partes[n])) continue;
      achou = true;
      var t;
      try { t = decodeURIComponent(partes[n].slice(5).replace(/\+/g, ' ')); } catch (e) { return href; }
      partes[n] = 'text=' + encodeURIComponent(comOrigem(t, o.k));
    }
    if (!achou) partes.push('text=' + encodeURIComponent(comOrigem('', o.k)));
    return base + '?' + partes.join('&') + hash;
  }

  function noLink(a) {
    if (!a || !a.getAttribute) return;
    var h = a.getAttribute('href');
    if (!h || h.indexOf('whatsapp') < 0 && h.indexOf('wa.me') < 0) return;
    var novo = ajustar(h);
    if (novo !== h) a.setAttribute('href', novo);
  }
  function perto(el) {
    while (el && el.nodeType === 1) { if (el.tagName === 'A') return el; el = el.parentNode; }
    return null;
  }
  function tocar(ev) { noLink(perto(ev.target)); }

  /* links que já estão na página e os que aparecem depois (gaveta, janela do produto) */
  function varrer() {
    if (!ler()) return;
    var ls = document.querySelectorAll('a[href*="wa.me/"], a[href*="whatsapp.com/send"]');
    for (var i = 0; i < ls.length; i++) noLink(ls[i]);
  }
  varrer();
  document.addEventListener('click', tocar, true);
  document.addEventListener('auxclick', tocar, true);
  document.addEventListener('contextmenu', tocar, true);
  document.addEventListener('touchstart', tocar, { capture: true, passive: true });

  /* quem abre o WhatsApp por código (window.open) também leva a origem */
  var abrir = window.open;
  if (typeof abrir === 'function') {
    window.open = function (u) {
      var args = Array.prototype.slice.call(arguments);
      if (typeof u === 'string') args[0] = ajustar(u);
      return abrir.apply(window, args);
    };
  }

  window.ONM = window.ONM || {};
  window.ONM.origemWhatsApp = { canal: function () { var o = ler(); return o ? o.k : ''; }, ajustar: ajustar, comOrigem: comOrigem };
})();
